





























import { BuildingState } from '@/store/types';
import Vue from 'vue';

export default Vue.extend({
  async mounted(): Promise<void> {
    await this.$store.dispatch('loadBuildings');
  },
  methods: {
    pricePerMeter(price: number, square: number): string {
      return this.numberWithSpaces(Math.ceil(price / square));
    },
    numberWithSpaces(x: number): string {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
  },
  computed: {
    buildings(): Array<BuildingState> {
      return this.$store.getters.getBuildings;
    },
  },
});
